import { z } from 'zod'
export const insertSchema = z
  .object({
    numero_nota: z.string(),
    codigo_parceiro: z.string(),
    codigo_contato: z.string(),
    numero_pedido: z.string(),
    dataRetorno: z.string().nonempty('Campo obrigatório'),
    horaRetorno: z.string().nonempty('Campo obrigatório'),
    observacoes: z.string().nonempty('Campo obrigatório'),
    agendamentoRetorno: z.string().nonempty().default('EMAIL'),
    assunto_email: z.string().optional(),
    categoria_email: z
      .object({
        value: z.number().int().positive().optional(),
        label: z.string(),
      })
      .optional(),
    mensagem_email: z
      .object({
        value: z.number().int().positive().optional(),
        label: z.string().nonempty(),
        preview: z.string().nonempty(),
        conteudo_mensagem: z.string().optional(),
      })
      .optional(),
    assunto_email_select: z.string().optional(),
    mensagem: z.string().optional(),
    mensagem_whatsapp: z
      .object({
        id_mensagem: z.number().int().positive().optional(),
        label: z.string().nonempty(),
        preview: z.string().nonempty(),
      })
      .optional(),
    categoria: z
      .object({
        value: z.number().int().positive().optional(),
        label: z.string().nonempty(),
      })
      .optional(),
  })
  .superRefine((data, ctx) => {
    // if (data.agendamentoRetorno !== 'TELEFONE' && !data.mensagem) {
    //   ctx.addIssue({
    //     code: z.ZodIssueCode.custom,
    //     message: 'Campo obrigatório',
    //     path: ['mensagem'],
    //   })
    // }

    if (data.agendamentoRetorno === 'EMAIL' && !data.categoria_email) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Campo obrigatório',
        path: ['categoria_email'],
      })
    }

    if (data.agendamentoRetorno === 'EMAIL' && !data.mensagem) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Campo obrigatório',
        path: ['mensagem'],
      })
    }

    //se for whatsapp precisa teer categoria
    if (data.agendamentoRetorno === 'WHATSAPP' && !data.categoria) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Campo obrigatório',
        path: ['categoria'],
      })
    }

    if (data.agendamentoRetorno === 'WHATSAPP' && !data.mensagem_whatsapp) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Campo obrigatório',
        path: ['mensagem_whatsapp'],
      })
    }

    //não deixa ele selecionar um prazo maior que 20 dias da data de hoje

    const dataRetorno = new Date(data.dataRetorno)
    const hoje = new Date()
    const diff = Math.abs(dataRetorno.getTime() - hoje.getTime())
    const diffDays = Math.ceil(diff / (1000 * 3600 * 24))

    if (diffDays > 20) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Data de retorno não pode ser maior que 20 dias',
        path: ['dataRetorno'],
      })
    }

    // Removendo a validação obrigatória do assunto_email
    if (data.agendamentoRetorno === 'EMAIL' && data.assunto_email && data.assunto_email.length > 90) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Máximo de 40 caracteres',
        path: ['assunto_email'],
      })
    }
  })
